export type FooterLink = {
  label: string
  to: string
}

export type FooterColumn = {
  heading: string
  links: FooterLink[]
}

export const footerColumns: FooterColumn[] = [
  {
    heading: 'Our solutions',
    links: [
      { label: 'Custom web design', to: '/#solutions' },
      { label: 'Ecommerce websites', to: '/#ecommerce' },
      { label: 'SEO + marketing structure', to: '/#ai-seo' },
      { label: 'API integrations', to: '/#solutions' },
      { label: 'Website redesigns', to: '/#solutions' },
      { label: 'Responsive web design', to: '/#solutions' },
    ],
  },
  {
    heading: 'Managed services',
    links: [
      { label: 'CMS & content updates', to: '/#support' },
      { label: 'Hosting & SSL', to: '/#support' },
      { label: 'Backups & security', to: '/#support' },
      { label: 'Training', to: '/#support' },
      { label: 'Analytics & tracking', to: '/#support' },
      { label: 'Remote Hands', to: '/#support' },
    ],
  },
  {
    heading: 'Explore',
    links: [
      { label: 'Portfolio', to: '/portfolio' },
      { label: 'Pricing plan', to: '/pricing-plan' },
      { label: 'Template vs custom', to: '/#comparison' },
      { label: 'How we use AI', to: '/#ai-seo' },
      { label: 'Our process', to: '/#support' },
      { label: 'Get started', to: '/#get-started' },
    ],
  },
]

export const legalLinks: FooterLink[] = [
  { label: 'Privacy policy', to: '/' },
  { label: 'Terms of service', to: '/' },
  { label: 'Accessibility', to: '/' },
  { label: 'Sitemap', to: '/' },
]
